// extracted by mini-css-extract-plugin
module.exports = {"inlineControl":"LanguageAndRegion__inlineControl___uYNUn"};